/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPTITLE = {
    Mr: 'MR',
    Mrs: 'MRS',
    Ms: 'MS',
    Miss: 'MISS',
    Dr: 'DOCTOR',
    Bishop: 'BISHOP',
    Captain: 'CAPTAIN',
    Father: 'FATHER',
    Judge: 'JUDGE',
    Lady: 'LADY',
    Master: 'MASTER',
    Professor: 'PROFESS',
    Sir: 'SIR',
    Colonel: 'COLONEL',
    Major: 'MAJOR',
    Princess: 'PRINC',
    Prince: 'PRINCE',
    Admiral: 'ADMIRAL',
    Advocate: 'ADVOCATE',
    Brigadier: 'BRIGADIER',
    Commissioner: 'COMMISSIONER',
    Commodore: 'COMMODORE',
    Director: 'DIRECTOR',
    Doctor: 'DOCTOR2',
    EstLate: 'ESTLATE',
    General: 'GENERAL',
    Honourable: 'HONOURABLE',
    Inspector: 'INSPECTOR',
    LieutCol: 'LIEUTCOL',
    Lieutenant: 'LIEUTENANT',
    LtCmdr: 'LTCMDR',
    Magistrate: 'MAGISTRATE',
    Minister: 'MINISTER',
    Pastor: 'PASTOR',
    President: 'PRESIDENT',
    Rabbi: 'RABBI',
    Reverend: 'REVEREND',
    Sergeant: 'SERGEANT',
    Sister: 'SISTER',
    Sup: 'SUP',
    SnrSup: 'SNRSUP',
    TheHon: 'THEHON',
    MajorGen: 'MAJORGEN',
    Mayor: 'MAYOR'
} as const;
export type IAPTITLE = typeof IAPTITLE[keyof typeof IAPTITLE];


export function IAPTITLEFromJSON(json: any): IAPTITLE {
    return IAPTITLEFromJSONTyped(json, false);
}

export function IAPTITLEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPTITLE {
    return json as IAPTITLE;
}

export function IAPTITLEToJSON(value?: IAPTITLE | null): any {
    return value as any;
}

